import styles from "../SlickCarousalPDP/slickSlide.module.scss";

import React, { useState, useEffect } from "react";
import Srcset from "../common/Srcset";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import VideoComp from "../VideoComp";

export default function SlickSlider({ onRequestClose, productImage, toggleModal }) {
  // filtering out videos (Video to be displayed on Desktop only)
  productImage = productImage.filter((ele) => ele?.type !== "VIDEO");
  var count = productImage.length;
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);
  const myLoader = ({ src, width, height, quality }) => {
    return `${src}?w=${width}&h=${height}&q=${quality || 75}`;
  };
  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
    if(slider1){
      document.querySelector(".main-pdp-slider .slick-arrow").setAttribute("tabindex",0);
      slider1.innerSlider.list.querySelectorAll(".slick-cloned img").forEach(img => img.tabIndex = -1);
    }
    if(slider2){
      slider2.innerSlider.list.querySelectorAll(".slick-cloned img").forEach(img => img.tabIndex = -1);
    }
  }, [slider1, slider2]);

  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    className: "main-pdp-slider tangiblee-ref",
    infinite: true,
    asNavFor: ".slider-nav",
    //vertical: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          vertical: false,
        },
      },
    ],
  };

  const settingsThumbs = {
    slidesToShow: count > 4 ?  5 : count,
    infinite: true,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: "0px",
    verticalSwiping: true,
    //vertical: true,
    arrows: true,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: count > 3 ?  4 : count,
        },
      },
      {
        breakpoint: 767,
        settings: {
          vertical: false,
        },
      },
    ],
  };
  if (productImage) {
    const slidesData = productImage.map((ele, index) => {
      if (ele.type && ele.type === "video") {
        let videoSrc = "";
        Object.values(ele).forEach((src, index) => {
          if (index == 0) {
            videoSrc=src.url;
          }
        })
        return (
          <VideoComp vidSrc={videoSrc} autoPlay={true} thumbnail={false}/>
        )
        } else {
        return (
          <Srcset
            loader={myLoader}
            className={`${styles.slick_slide_image}`}
            layout="responsive"
            src={ele.url}
            alt={ele.alt}
            data-title={ele.title}
            onClick={toggleModal}
            id={`second ${index}`}
            height="100%"
            width="100%"
            tabIndex={0}
          />
        );
      }
    });
    const slidesData2 = productImage.map((ele, index) => {
      if (ele.type && ele.type === "video") {
        let videoSrc = "";
        Object.values(ele).forEach((src, index) => {
          if (index == 0) {
            videoSrc=src.url;
          }
        })
        return (
          <>
            <VideoComp vidSrc={videoSrc} autoPlay={false} thumbnail={true}/>
            <span className="img-bg ga_video_slider_thumbnail_click"></span>
          </>
        )
      } else {
        return (
          <>
            <Srcset
              loader={myLoader}
              layout="responsive"
              src={ele.url}
              alt={ele.alt}
              data-title={ele.title}
              id={index}
              height="100%"
              width="100%"
              tabIndex={0}
            />
            <span className="img-bg ga_slider_thumbnail_click"></span>
          </>
        );
      }
    });
    return (
      <>
        <div className={styles.slider_wrapper}>
          <Slider
            {...settingsMain}
            asNavFor={nav2}
            ref={(slider) => setSlider1(slider)}
          >
            {slidesData.map((slide, index) => (
              <div key={index}>{slide}</div>
            ))}
          </Slider>
          <div
            className={`${styles.thumbnail_slider_wrap} ${
              count === 1 ? `${styles.one}` : ""
            }              
              ${count === 2 ? `${styles.two}` : ""}
                ${count === 3 ? `${styles.three}` : ""}
              `}
          ><div className={styles.side_overlay}></div>
            <Slider
              {...settingsThumbs}
              asNavFor={nav1}
              ref={(slider) => setSlider2(slider)}
            >
              {slidesData2.map((slide, index) => (
                <div className={styles.slick_slider} key={index}>
                  {slide}
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </>
    );
  }
}
